import React, {
  FunctionComponent, useCallback, useEffect, useState
} from 'react';
import { useDispatch } from 'react-redux';
import { Link, Route, Switch, useHistory } from 'react-router-dom';
import { ListItemIcon, MenuItem, Theme, Link as MuiLink, Box, Button } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { Tenant } from '@ivymobi/orbit-core';
import {
  createTenantAction, getOneMemberAction, getHasEmailAction, listTenantsAction, uploadAction, updateTenantAction,
  getTemplateSample2InfoAction,
} from '@ivymobi/orbit-core/business/tenant';
// import {
//   getCheckInfoAction,
// } from '@ivymobi/orbit-core/business/document';
import { getCheckInfoAction } from '@ivymobi/orbit-core/business/user';
import { TenantContext, UserContext, TeammessageContext, WebSiteContext, DeviceType } from './orbit-context';
import AppBar from './layout/appbar';
import UserMenu from './layout/userMenu';
import TenantCreator from './settings/createTenant';
import TenantSwitch from './settings/switchTenant';
import Loader from './components/loaders';
import { CurrentTenant } from './tenant';
import { string32 } from 'pdfjs-dist/types/shared/util';
import { WebSiteRouters } from './webSiteRouters';
import { getRobotLocalesAction, getThirdTenantInfoAction, getUnitsInfoAction } from '@ivymobi/orbit-core/business/productCenter';
import copy from 'copy-to-clipboard';
import { resolveUrl } from './api';
import { Language } from '@mui/icons-material';
import Jumping from './components/jumping';
import Carousel from './components/Carousel/index.js'
import NavBar from './components/navbar/index.js'
import _ from 'lodash';
import useSWR from 'swr';
import { getTenantsModuleAction, getTenantsModuleArgs } from './apiV2';
import AI from './ai/AI';

//三菱图标
const TenantLogo: FunctionComponent<{ srcUrl: string }> = ({ srcUrl }) => {
  return (
    <MenuItem style={{ paddingLeft: '32px', overflow: 'unset' }} >
      <ListItemIcon>
        <img src={srcUrl ?? ''}
          style={{ height: '47px', marginRight: '8px' }}
        />
      </ListItemIcon>
    </MenuItem>
  );
};

const useStyles = makeStyles((theme: Theme) => createStyles({
  appFrame: () => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,

    "@media (min-width: 768px)": {
      marginTop: theme.spacing(10),
    },
    "@media (max-width: 768px)": {
      marginTop: theme.spacing(0),
    },

  }),
  childMode: {
    fontSize: '15px',
    paddingLeft: '10px',
    paddingRight: '10px',
    whiteSpace: 'nowrap',
    // textOverflow:'ellipsis',

  },
}));


export const Container = (props) => {
  const { webInfo, deviceType, doLogin } = props;
  const [bFirst, setBFirst] = useState(localStorage.getItem('isfisrt') === '1' ? false : true)
  const classes = useStyles();

  const urlParams = new URL(window.location.href);
  const pathname = urlParams?.pathname;
  const history = useHistory();
  const [parents, setParents] = useState([])
  const [title, setTitle] = useState('')

  const [showJump, setShowJump] = useState(false)
  const OpenUrl = (url) => {
    setShowJump(true)
    setTimeout(() => {
      setShowJump(false)
      window.open(url)
    }, 800);
  }
  const OnclickTip = () => {
    setBFirst(false)
    localStorage.setItem('isfisrt', '1');

  }

  const test = {

    // , {
    //   "title": "iQ-R",
    //   "image": "https://static-cdn.yangbentong.com/5b69800af42ca858565e337a.png",
    //   "link": "/iqr"
    // }, {
    //   "title": "iQ-F",
    //   "image": "https://static-cdn.yangbentong.com/5b890609ee68634ee7004fd3.png",
    //   "link": "/iqf"
    // }
    "modules": [{

      "config": {
        "pages": {
          "home": {
            "navigators": [{
              "title": "伺服系统",
              "image": "/images/index/sf.png",
              "link": "/sv"
            }, {
              "title": "低压配电系统",
              "image": "/images/index/dypd.png",
              "link": "/lv"
            }, {
              "title": "人机界面",
              "image": "/images/index/people.png",
              "link": "/got"
            }, {
              "title": "变频器",
              "image": "/images/index/bpq.png",
              "link": "/inv"
            }, {
              "title": "机器人",
              "image": "/images/index/robot.png",
              "link": "/robot"
            }, {
              "title": "FX3 PLC",
              "image": "/images/index/programe.png",
              "link": "/plc"
            }, {
              "title": "放电加工机",
              "image": "/images/index/fdjgj.png",
              "link": "/edm"
            }, {
              "title": "激光加工机",
              "image": "/images/index/jgjgj.png",
              "link": "/lm"
            }],

          },

        }
      }
    },

    ]
  }

  let modules = test.modules[0].config.pages.home.navigators

  if (pathname === '/') {
    console.log("================", classes.appFrame)
    return (<Box className={classes.appFrame} style={{ backgroundSize: 'cover', backgroundImage: 'url(/images/background.png)', marginTop: '0px' }}>
      <AppBar style={{ backgroundColor: '#8a2be200' }}>
        <TenantLogo srcUrl={webInfo?.webInfo?.tnt_info?.logo} />
      </AppBar>
      {bFirst && <Box onClick={() => {
        OnclickTip()

      }} style={{ display: 'flex', justifyContent: "center", alignItems: 'center', position: 'absolute', left: '0px', right: '0px', top: '0px', bottom: '0px', background: '#d5d2d2ad', zIndex: '9000' }}>
        <Box >
          <img onClick={() => {
            OnclickTip()

          }} src='images/tip1.png' style={{ width: deviceType === 'mobile' ? '30vw' : 'unset' }} />
          <img onClick={() => {
            OnclickTip()

          }} style={{ marginLeft: '50px', width: deviceType === 'mobile' ? '30vw' : 'unset' }} src='images/tip2.png' />
        </Box>

      </Box>}
      <Box style={{ width: '100%', height: 'calc(76vh)', position: 'relative', display: 'flex' }}>
        <Box style={{ position: 'relative', width: "100%", height: '100%', overflow: 'hidden' }}>
          <Carousel items={modules} history={history} addEvent={() => { }} />

        </Box>
      </Box>
      <Box>
        <Box style={{ height: '24vh', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
          <Box style={{ background: '#ffffffba', boxShadow: 'rgb(0 0 0 / 20%) 4px 0px 18px 0px', height: "100px", width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box style={{ position: 'relative', height: '100%', width: '180px', cursor: 'pointer' }}>

              <Box style={{ position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                <Box style={{ cursor: 'pointer', boxShadow: 'inset rgb(0 0 0 / 20%) -2px 1px 6px 0px', transform: 'skewX(-35deg)', position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                  <Box style={{ height: "4px", width: '100%', background: 'red' }}></Box>

                </Box>

                <Box onClick={() => {
                  history.push('/assets')
                }} style={{ fontSize: '18px', fontWeight: 'bolder', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>

                  <Box style={{ display: 'flex', justifyContent: 'center', alignItems: deviceType === 'mobile' ? 'center' : 'flex-end', flexDirection: deviceType === 'mobile' ? 'column' : 'row' }}>
                    <img src='/images/ffile.png'></img><Box style={{ marginBottom: '-5px', marginLeft: deviceType === 'mobile' ? 'unset' : '10px', fontSize: deviceType === 'mobile' ? '15px' : 'unset' }}>资料下载</Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box style={{ position: 'relative', height: '100%', width: '180px', cursor: 'pointer' }}>
              <Box style={{ position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                <Box style={{ cursor: 'pointer', boxShadow: 'inset rgb(0 0 0 / 20%) -2px 1px 6px 0px', transform: 'skewX(-35deg)', position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                  <Box style={{ height: "4px", width: '100%', background: 'red' }}></Box>

                </Box>
                <Box onClick={() => {
                  history.push('/about')
                }} style={{ fontSize: '18px', fontWeight: 'bolder', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                  <Box style={{ display: 'flex', justifyContent: 'center', alignItems: deviceType === 'mobile' ? 'center' : 'flex-end', flexDirection: deviceType === 'mobile' ? 'column' : 'row' }}>
                    <img src='/images/fabout.png'></img><Box style={{ marginBottom: '-5px', marginLeft: deviceType === 'mobile' ? 'unset' : '10px', fontSize: deviceType === 'mobile' ? '15px' : 'unset' }}>关于三菱电机</Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box style={{ position: 'relative', height: '100%', width: '180px', cursor: 'pointer' }}>
              <Box style={{ position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                <Box style={{ cursor: 'pointer', boxShadow: 'inset rgb(0 0 0 / 20%) -2px 1px 6px 0px', transform: 'skewX(-35deg)', position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                  <Box style={{ height: "4px", width: '100%', background: 'red' }}></Box>

                </Box>
                <Box onClick={() => {
                  history.push('/contact')
                }} style={{ fontSize: '18px', fontWeight: 'bolder', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
                  <Box style={{ display: 'flex', justifyContent: 'center', alignItems: deviceType === 'mobile' ? 'center' : 'flex-end', flexDirection: deviceType === 'mobile' ? 'column' : 'row' }}>
                    <img src='/images/fconst.png'></img><Box style={{ marginBottom: '-5px', marginLeft: deviceType === 'mobile' ? 'unset' : '10px', fontSize: deviceType === 'mobile' ? '15px' : 'unset' }}>联系我们</Box>
                  </Box>

                </Box>
              </Box>
            </Box>
            {/* <Button variant='outlined' color='primary' size="small" style={{minWidth: '96px' }}>升级版本</Button> */}
          </Box>
        </Box>
      </Box>
    </Box>)
  }
  return (
    <div className={classes.appFrame}>
      {showJump && <Jumping />}
      {deviceType === 'computer' && <AppBar>
        <TenantLogo srcUrl={webInfo?.webInfo?.tnt_info?.logo} />
        <Box style={{ flex: 1 }}>
          <MuiLink
            underline='hover'
            onClick={() => {
            }} component={Link} to='/sv' color={pathname.search('/sv') != -1 ? 'error' : 'textSecondary'} className={classes.childMode}>
            伺服系统
          </MuiLink>
          {/* <MuiLink component={Link}  onClick={()=>{
          OpenUrl('https://mitsubishielectric.yangben.cn/iqr')
        }}  color="textSecondary" to={null} className={classes.childMode}>
                iQ-R
        </MuiLink>
        <MuiLink component={Link} onClick={()=>{
          OpenUrl('https://mitsubishielectric.yangben.cn/iqr')
        }} color="textSecondary" to={null} className={classes.childMode}>
                iQ-F
        </MuiLink> */}
          <MuiLink underline='hover' component={Link} to='/lv' color={pathname.search('/lv') != -1 ? 'error' : 'textSecondary'} onClick={() => {
            // OpenUrl('https://mitsubishielectric.yangben.cn/lv')
          }} className={classes.childMode}>
            低压配电系统
          </MuiLink>
          <MuiLink underline='hover' component={Link} to='/got' onClick={() => {
          }} color={pathname.search('/got') != -1 ? 'error' : 'textSecondary'} className={classes.childMode}>
            人机界面
          </MuiLink>
          <MuiLink underline='hover' component={Link} to='/inv' onClick={() => {
          }} color={pathname.search('/inv') != -1 ? 'error' : 'textSecondary'} className={classes.childMode}>
            变频器
          </MuiLink>
          <MuiLink underline='hover' component={Link} to='/robot' color={pathname.search('/robot') != -1 ? 'error' : 'textSecondary'} style={{ fontWeight: pathname.search('/robot') != -1 ? 'bold' : 'unset' }} className={classes.childMode}>
            机器人
          </MuiLink>
          <MuiLink underline='hover' component={Link} to='/plc' onClick={() => {
          }} color={pathname.search('/plc') != -1 ? 'error' : 'textSecondary'} className={classes.childMode}>
            可编程控制器
          </MuiLink>
          <MuiLink underline='hover' component={Link} to='/edm' onClick={() => {
          }} color={pathname.search('/edm') != -1 ? 'error' : 'textSecondary'} className={classes.childMode}>
            放电加工机
          </MuiLink>
          <MuiLink underline='hover' component={Link} to='/lm' onClick={() => {
          }} color={pathname.search('/lm') != -1 ? 'error' : 'textSecondary'} className={classes.childMode}>
            激光加工机
          </MuiLink>
          <MuiLink underline='hover' component={Link} to={'/assets'} color={pathname.search('/assets') != -1 ? 'error' : 'textSecondary'} onClick={() => {
          }} className={classes.childMode}>
            资料下载
          </MuiLink>
          <MuiLink underline='hover' component={Link} to={'/about'} color={pathname.search('/about') != -1 ? 'error' : 'textSecondary'} onClick={() => {
          }} className={classes.childMode}>
            关于三菱电机
          </MuiLink>
          <MuiLink underline='hover' component={Link} to={'/contact'} color={pathname.search('/contact') != -1 ? 'error' : 'textSecondary'} onClick={() => {
          }} className={classes.childMode}>
            联系我们
          </MuiLink>
        </Box>
        <MuiLink underline='hover' component={Link} to={null} onClick={() => {
          //生产环境改
          OpenUrl('https://lite.yangbentong.com/user/signin?from=mitsubishi')
          // OpenUrl('https://lite.ivymobi.net/user/signin?from=mitsubishi')
        }} color="textSecondary" style={{ display: 'flex', alignItems: 'center', fontSize: '18px' }} className={classes.childMode}>
          {window.parent.length == 0 && <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src='/images/login.png' /> <div style={{ paddingLeft: '5px', color: 'black' }}>登录</div>
          </div>}
        </MuiLink>
        <MuiLink underline='hover' to={null} onClick={() => {
          copy(resolveUrl(`/robot`));
          alert('复制链接成功');

        }} component={Link} color="textSecondary" style={{ display: 'flex', alignItems: 'center', fontSize: '18px' }} className={classes.childMode}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src='/images/mshare.png' />
          </div>
        </MuiLink>
        {/* <UserMenu logout={props.logout} /> */}
      </AppBar>}
      {deviceType === 'mobile' && <NavBar
        user={null}
        title={title}
        onShareClick={false}
        onCollectionClick={false}
        parents={[
          { to: '/', name: '首页' }, ...parents,
        ]} />}

      <WebSiteContext.Provider value={webInfo}>
        <DeviceType.Provider value={deviceType}>
          <WebSiteRouters doLogin={doLogin} OpenUrl={OpenUrl} setParents={setParents} setTitle={setTitle}></WebSiteRouters>
        </DeviceType.Provider>
      </WebSiteContext.Provider>
    </div>
  );
};


const ActiveContainer = ({ doLogin, logout }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [websiteInfo, setWebsiteInfo] = useState(null);
  const [deviceType, setDeviceType] = useState<'computer' | 'mobile'>('computer');
  const [tntId, setTntId] = useState<string>(null);

  useEffect(() => {
    console.log("tyupe================", deviceType)
  }, [deviceType])

  const computerDevice = () => {
    let screenWidth = document.body.offsetWidth
    if (screenWidth < 768) {
      setDeviceType('mobile')
    } else {
      setDeviceType('computer')
    }
  }

  useEffect(() => {
    computerDevice()
    window.addEventListener('resize', () => {
      computerDevice()
    })
    // const info = _.get(res, ['data']);
    // setWebsiteInfo(prev => ({...prev, acl:{required:info[0]?.required??[], visitor_info:info[0]?.visitor_info??[], eoi:info[0]?.eoi??[]}}));
    dispatch(getThirdTenantInfoAction({ tenantIndex: 'Mitsubishi' })).then((res) => {
      dispatch(getRobotLocalesAction({ user: { token: null, user: null }, tenant: { id: res[0].tnt_id }, local: 'zh' })).then(language => {
        dispatch(getUnitsInfoAction({ tenantId: res[0].tnt_id })).then((Units) => {
          dispatch(getTemplateSample2InfoAction({ tenant: { id: res[0].tnt_id }, language: 'zh', user: { token: '' } })).then(acl => {
            const info = _.get(acl, ['data']);
            setWebsiteInfo({
              acl: { required: info[0]?.required ?? [], visitor_info: info[0]?.visitor_info ?? [], eoi: info[0]?.eoi ?? [] }, webInfo: res.length > 0 ? res[0] : null, language: language, Units: Units, getUnit: (ftId) => {
                for (let i = 0; i < Units.length; i++) {
                  if (Units[i].ftId === ftId)
                    return Units[i]?.unitCode
                }
                return ''
              }
            });
          })


        })
      })

    });
  }, []);

  useEffect(() => {
    if (websiteInfo) {
      const tId = websiteInfo?.webInfo?.tnt_id;
      setTntId(tId);
    }
  }, [websiteInfo]);

  const {
    data: { types: moduleTypes = [], data: moduleData = {} } = {}
  } = useSWR(
    getTenantsModuleArgs({tid: tntId }),
    getTenantsModuleAction,
    { suspense: true }
  );

  const ai_search = moduleTypes.includes('ai_search')
    ? moduleData['ai_search'].open_or_not
    : '0';

  if (!websiteInfo) {
    return <Loader></Loader>
  }
  return (
    <>
      <Container
        logout={logout}
        doLogin={doLogin}
        webInfo={websiteInfo}
        deviceType={deviceType}
      />
      {ai_search === '1' && <AI tid={tntId} deviceType={deviceType} />}
    </>
  );
};

export default ActiveContainer;
